import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';

const style = new Style({
	image: new Circle({
		radius: 6,
		fill: new Fill({
			color: '#0084bd',
		}),
		stroke: new Stroke({
			color: '#fff',
			width: 2,
		}),
	}),
});

export default style;
